import { z } from 'zod';

import { Option } from '../../types/Option';

const ACPortConfigurations = [
    'single-phase',
    'split-phase',
    'three-phase-wye-neutral',
    'three-phase-wye',
    'three-phase-delta',
] as const;

type ACPortConfiguration = (typeof ACPortConfigurations)[number];

const options = [
    { value: 'single-phase', label: 'Single Phase' },
    { value: 'split-phase', label: 'Split Phase' },
    { value: 'three-phase-wye-neutral', label: 'Three Phase Y Neutral' },
    { value: 'three-phase-wye', label: 'Three Phase Y' },
    { value: 'three-phase-delta', label: 'Three Phase Delta' },
] as Option<ACPortConfiguration>[];

const validator = z.enum(ACPortConfigurations).nullable().default(null);

export const ACPortConfiguration = {
    validator,
    options,
};
